import {
  executeAction,
  getAddGlobalVarAction,
  getDeleteGlobalVarAction,
  getEditGlobalVarAction,
} from '@ps/workbench/undo-redo'
import _ from 'lodash'
import { updateGamePlayGlobalVar } from '@ps/bridge/qc/node/game-play'
import { Event, EventBus } from '@ps/utils/event-bus'

const globalVar = {
  namespaced: true,

  state: {
    globalVar: [],
    supportGlobalVar: false,
    dialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '438px',
      top: '88px',
      onReplaced: () => {},
    },
    dialogStyle: {
      left: '',
      right: '',
    },
    dialogConditionId: null,
    dialogConditionEventItemId: null,
  },

  mutations: {
    updateGlobalVar(state, data) {
      console.log(data)
      state.globalVar = data
      updateGamePlayGlobalVar(data)
      EventBus.$emit(Event.GLOBALVAR_UPDATE)
    },
    updateSupportGlobalVar(state, data) {
      state.supportGlobalVar = data
    },
    openDialog(state) {
      state.dialog.visible = true
    },
    closeDialog(state) {
      state.dialog.visible = false
    },
    moveDialogToRight(state) {
      state.dialogStyle = {
        right: 'calc(641px - 100vw)',
        left: 'auto',
      }
    },
    updateDialogConditionId(state, id) {
      state.dialogConditionId = id
    },
    updateDialogConditionEventItemId(state, eventItemId) {
      state.dialogConditionEventItemId = eventItemId
    },
  },

  actions: {
    addGlobalVar({ state }, { data, record = true }) {
      executeAction({
        action: getAddGlobalVarAction({
          newValue: data,
          oldValue: _.cloneDeep(state.globalVar),
        }),
        record,
      })
    },
    deleteGlobalVar({ state }, { index, record = true }) {
      executeAction({
        action: getDeleteGlobalVarAction({
          newValue: index,
          oldValue: _.cloneDeep(state.globalVar),
        }),
        record,
      })
    },
    editGlobalVar({ state }, { index, data, record = true }) {
      executeAction({
        action: getEditGlobalVarAction({
          newValue: { index, data },
          oldValue: _.cloneDeep(state.globalVar),
        }),
        record,
      })
    },
    async updateGlobalVarBackup({ state }) {
      if (state.supportGlobalVar) {
        updateGamePlayGlobalVar(state.globalVar)
      }
    },
  },
}

export default globalVar
